import solver from 'solver-utilities';
import { search as api } from './shopify.js';
import { error } from './notification.js';
import { TYPES } from './types.js';

let inputTimeout = null;

const onKeyup = async function (event, name) {
  if (!event) return;

  const container = document.querySelector(`[data-el="${name}-results"]`);
  const target = event.currentTarget;
  const value = target.value;
  const closeButton = document.querySelector(`[data-el="search-clear"]`);
  const placeholder = document.querySelector(`[data-el="search-results--placeholder"]`);

  if (value.length) {
    closeButton.classList.remove('hide');
  } else {
    closeButton.classList.add('hide');
  }

  if (inputTimeout) clearTimeout(inputTimeout);
  inputTimeout = null;

  inputTimeout = setTimeout(async () => {
    clearTimeout(inputTimeout);
    inputTimeout = null;

    const req = await api.get(value, 10, `search-results`);

    if (req.data && container) {
      container.innerHTML = req.data;
      placeholder.classList.add('hide');
    }

    if (!req.data) {
      container.innerHTML = '';
      placeholder.classList.remove('hide');
    }
  }, 500);
};

const clearSearch = function () {
  const input = document.querySelector('[data-el="search-input"]');
  const closeButton = document.querySelector('[data-el="search-clear"]');
  const container = document.querySelector(`[data-el="global-search-results"]`);
  const placeholder = document.querySelector(`[data-el="search-results--placeholder"]`);

  input.value = '';
  input.focus();
  closeButton.classList.add('hide');
  placeholder.classList.remove('hide');
  container.innerHTML = '';

  closeButton.addEventListener('click', clearSearch);
};

const open = async function (event) {
  if (event) event.preventDefault();

  const container = document.querySelector('.global-search-flyout');

  if (!container) return;

  container.classList.add('global-search-flyout--active');

  await solver.frontend.asyncTimeout(100);

  const form = container.querySelector('[data-el="global-search"]');

  if (!form) return;

  form.classList.add('form--active');

  const input = container.querySelector('input');

  if (!input) return;

  input.focus();
};

export const close = async function (event) {
  if (event) event.preventDefault();

  const container = document.querySelector('.global-search-flyout');

  if (!container) return;

  const form = container.querySelector('[data-el="global-search"]');

  if (!form) return;

  form.classList.remove('form--active');

  await solver.frontend.asyncTimeout(200);

  container.classList.remove('global-search-flyout--active');
  clearSearch();
};

export const search = function (delay) {
  clearSearch();
  window.Solver.onSearch = onKeyup;
  window.Solver.openHeaderSearch = open;
  window.Solver.closeHeaderSearch = close;
  window.Solver.clearSearch = clearSearch;

  const displayedProducts = document.querySelectorAll('main [data-product-card]');
  const lengthEl = document.querySelector('[data-el="search-results-length"]');

  if (displayedProducts && lengthEl) {
    lengthEl.innerText = displayedProducts.length;
    document.title = 'Search: ' + displayedProducts.length + ' results found';
  }
};
